/* WL saved-artworks header count — presentation glue only.
   ONE dataset rule: the saved list lives in localStorage.wl_selected and is OWNED
   by wl_bar.js (PDP "Save" button, View-all-saved at /collections/all?wlsaved=1,
   email-my-list). This file never writes it — it only paints the count bubble on
   the header heart (#wl-saved-count, sections/header.liquid, desktop AND mobile).
   Deploy: python3 wl_deploy.py saved  ->  LIVE theme assets/wl-saved.js */
(function () {
  "use strict";
  function count() {
    try { return (JSON.parse(localStorage.wl_selected || "[]") || []).length; }
    catch (e) { return 0; }
  }
  function paint() {
    var el = document.getElementById("wl-saved-count");
    if (!el) return;
    var n = count();
    var txt = n > 30 ? "30+" : String(n);
    if (el.textContent !== txt) el.textContent = txt;
    if (el.hidden !== (n === 0)) el.hidden = (n === 0);
  }
  /* wl_bar's save/remove buttons expose no event — repaint shortly after any
     click (the list is <=30 items; this is negligible work) */
  document.addEventListener("click", function () { setTimeout(paint, 250); }, true);
  window.addEventListener("storage", paint);   /* other tabs */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", paint);
  } else { paint(); }
})();
